import React, { useState, useEffect, useRef } from "react";
import {
  WindowsContainer,
  WindowsTabs,
  WindowsTab,
  WindowsContent,
  WindowsPanel,
  WindowsTabTitle,
  WindowsTabIcon,
} from "./CustomWindowsStyles";
import { FileOutlined } from "@ant-design/icons";
import Colors from "../../themes/Colors";

const CustomWindows = ({
  windows = [],
  defaultActiveWindow = 0,
  onWindowChange,
  onWindowClose,
  tabPosition = "top",
  className = "",
  style = {},
  panelOverflow,
}) => {
  const [activeWindow, setActiveWindow] = useState(defaultActiveWindow);
  const [visibleWindows, setVisibleWindows] = useState(windows);

  useEffect(() => {
    setVisibleWindows(windows);
  }, [windows]);

  useEffect(() => {
    if (onWindowChange) {
      onWindowChange(activeWindow, windows[activeWindow]);
    }
  }, [activeWindow, onWindowChange, windows]);

  const handleWindowChange = (windowIndex) => {
    if (windowIndex >= 0 && windowIndex < visibleWindows.length) {
      setActiveWindow(windowIndex);
    }
  };

  const showWindow = (windowId) => {
    const windowIndex = visibleWindows.findIndex(
      (window) => window.id === windowId
    );
    if (windowIndex !== -1) {
      handleWindowChange(windowIndex);
    }
  };

  const addWindow = (newWindow) => {
    const updatedWindows = [...visibleWindows, newWindow];
    setVisibleWindows(updatedWindows);
    setActiveWindow(updatedWindows.length - 1);
  };

  const updateWindow = (windowId, updatedData) => {
    const updatedWindows = visibleWindows.map((window) =>
      window.id === windowId ? { ...window, ...updatedData } : window
    );
    setVisibleWindows(updatedWindows);
  };

  const ref = useRef();

  React.useImperativeHandle(
    ref,
    () => ({
      showWindow,
      addWindow,
      updateWindow,
      setActiveWindow: handleWindowChange,
      getActiveWindow: () => activeWindow,
      getVisibleWindows: () => visibleWindows,
    })
  );

  if (visibleWindows.length === 0) {
    return (
      <WindowsContainer className={className} style={style}>
        <WindowsContent>
          <WindowsPanel>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                color: "#666",
                fontSize: "16px",
              }}
            >
              No hay ventanas disponibles
            </div>
          </WindowsPanel>
        </WindowsContent>
      </WindowsContainer>
    );
  }

  return (
    <WindowsContainer ref={ref} className={className} style={style}>
      {tabPosition === "top" && (
        <WindowsTabs>
          {visibleWindows.map((window, index) => (
            <WindowsTab
              key={window.id || index}
              active={index === activeWindow}
              onClick={() => handleWindowChange(index)}
            >
              <WindowsTabIcon active={index === activeWindow}>
                {window.icon || (
                  <FileOutlined
                    style={{
                      fontSize: "16px",
                      color:
                        index === activeWindow
                          ? Colors.primaryHumano
                          : Colors.grayFont,
                    }}
                  />
                )}
              </WindowsTabIcon>
              <WindowsTabTitle active={index === activeWindow}>
                {window.title || `Ventana ${index + 1}`}
              </WindowsTabTitle>
            </WindowsTab>
          ))}
        </WindowsTabs>
      )}

      <WindowsContent>
        <WindowsPanel overflow={panelOverflow}>
          {visibleWindows[activeWindow] && (
            <div style={{ width: "100%", height: "100%" }}>
              {typeof visibleWindows[activeWindow].content === "function"
                ? visibleWindows[activeWindow].content()
                : visibleWindows[activeWindow].content}
            </div>
          )}
        </WindowsPanel>
      </WindowsContent>

      {tabPosition === "bottom" && (
        <WindowsTabs>
          {visibleWindows.map((window, index) => (
            <WindowsTab
              key={window.id || index}
              active={index === activeWindow}
              onClick={() => handleWindowChange(index)}
            >
              <WindowsTabIcon active={index === activeWindow}>
                {window.icon || (
                  <FileOutlined
                    style={{
                      fontSize: "16px",
                      color:
                        index === activeWindow
                          ? Colors.primaryHumano
                          : Colors.grayFont,
                    }}
                  />
                )}
              </WindowsTabIcon>
              <WindowsTabTitle active={index === activeWindow}>
                {window.title || `Ventana ${index + 1}`}
              </WindowsTabTitle>
            </WindowsTab>
          ))}
        </WindowsTabs>
      )}
    </WindowsContainer>
  );
};

export default CustomWindows;
